import type { ComponentChildren } from 'preact';

import { Link } from '../components/Link.tsx';
import { PageLayout } from '../components/PageLayout.tsx';
import { Problem } from '../components/Problem.tsx';
import { usePostIndex } from '../hooks/usePostIndex.ts';
import css from './BlogPage.module.css';

export const BlogPage = () => {
  const index = usePostIndex();

  let content: ComponentChildren;

  if (index.value != null) {
    const postItems = index.value.posts.map((post) => {
      return (
        <>
          <dt class={css.itemTitle}>{new Date(post.created).toLocaleString()}</dt>
          <dd class={css.itemContent}>
            <article>
              <Link href={`/blog/${post.id}`} variant="nav">
                <h1 class={css.postTitle}>{post.title}</h1>
              </Link>
              {post.summary && <p class={css.postSummary}>{post.summary}</p>}
            </article>
          </dd>
        </>
      );
    });

    content = <dl class={css.list}>{postItems}</dl>;
  } else {
    content = <Problem />;
  }

  return (
    <PageLayout
      title="Blog"
      nav={
        <Link href="/blog" variant="nav">
          Blog
        </Link>
      }
      footer={
        <div class={css.footer}>
          Subscribe via{' '}
          <Link href="/blog/feed.atom" target="_blank">
            RSS
          </Link>
          .
        </div>
      }
    >
      <section>{content}</section>
    </PageLayout>
  );
};
